import { useCallback } from 'react';

import { useLiveRef } from './useLiveRef';

/**
 * A hook that converts a function into a stable reference, similar to [_, setX] = useState().
 *
 * @param fn - Function to be converted into a stable reference.
 * @returns Stable reference to the latest function.
 */
export const useStableFunction = <T extends (...args: any[]) => any>(
  fn: T,
): T => {
  const fnRef = useLiveRef(fn);
  return useCallback(
    (...args: Parameters<T>) => fnRef.current(...args),
    [fnRef],
  ) as T;
};
